module.exports = __webpack_public_path__ + "img/vicgov.6a5f9796.png";